export function capitalizeKeys(obj: Record<string, unknown>): Record<string, unknown> {
  const newObj: Record<string, unknown> = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key.charAt(0).toUpperCase() + key.slice(1)] = obj[key];
    }
  }
  return newObj;
}
